import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "परिचय ", "id": "about-diploma" },
    { "name": "कार्य एवं उद्देश्य", "id": "functions-objectives" },
    { "name": "समय सारिणी", "id": "timetable" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

const contentData = {
    "about-diploma": (
        <>
            <p>पौरोहित्य एवं कर्मकाण्ड भारतीय धार्मिक और सांस्कृतिक परंपराओं का एक महत्वपूर्ण अंग है। विश्वविद्यालय स्तर पर इस विषय को पढ़ाने के कई महत्वपूर्ण पहलू हैं पौरोहित्य और कर्मकाण्ड का अध्ययन केवल धार्मिक कर्मकाण्ड तक सीमित नहीं, बल्कि यह संस्कृति, समाज और व्यक्तिगत आध्यात्मिक उन्नति का आधार भी है। विश्वविद्यालय स्तर पर यह विषय पारंपरिक ज्ञान और आधुनिक अनुसंधान का समन्वय बनाकर सनातन परंपराओं को नई ऊर्जा प्रदान करता है।</p>
            <p>वैदिक कर्मकाण्ड सनातन धर्म और कई अन्य आध्यात्मिक परंपराओं में एक महत्वपूर्ण स्थान रखता है। यह विभिन्न धार्मिक अनुष्ठानों, यज्ञों, पूजाओं और संस्कारों का एक समूह है, जो व्यक्ति के आध्यात्मिक, मानसिक और सामाजिक जीवन को शुद्ध करने और संतुलित रखने में सहायक होता है। यह समाज के आर्थिक सामाजिक मानसिक उन्नयन में अत्यंत महत्वपूर्ण है।</p>
        </>
    ),
    "functions-objectives": (
        <>
            <h5>कार्य एवं उद्देश्य</h5>
            <h6>शास्त्रों एवं परंपराओं का संरक्षण</h6>
            <ul>
                <li>वैदिक ग्रंथों, पुराणों, स्मृतियों और संहिताओं का गहन अध्ययन होता है।</li>
                <li>वैदिक मंत्रों, यज्ञ-विधियों, संस्कारों और अनुष्ठानों की वैज्ञानिक व दार्शनिक समझ विकसित होती है।</li>
                <li>सनातन धर्म की परंपराओं को संरक्षित एवं आगे बढ़ाने का कार्य होता है।</li>
            </ul>

            <h6>प्रमाणिक और प्रशिक्षित पुरोहितों का निर्माण</h6>
            <ul>
                <li>सही उच्चारण, विधियों और प्रक्रिया का शिक्षण दिया जाता है, जिससे अशुद्धि न हो।</li>
                <li>धार्मिक अनुष्ठानों और संस्कारों का गहन प्रशिक्षण दिया जाता है, जिससे समाज को योग्य पुरोहित मिल सकें।</li>
            </ul>

            <h6>समाज के लिए व्यावहारिक उपयोगिता</h6>
            <ul>
                <li>विवाह, उपनयन, श्राद्ध, यज्ञ आदि संस्कारों की शुद्ध एवं प्रभावी विधियों का ज्ञान मिलता है।</li>
                <li>समाज को धार्मिक रूप से शिक्षित करने में प्रशिक्षित पुरोहितों की भूमिका अहम होती है।</li>
            </ul>

            <h6>रोजगार और करियर के अवसर</h6>
            <ul>
                <li>प्रमाणित पुरोहित, भारतीय सेना में धर्मगुरु, संस्कृत शिक्षक, ज्योतिषाचार्य, शोधकर्ता, धार्मिक लेखक, वेदपाठी आदि के रूप में करियर बन सकता है।</li>
                <li>विश्वविद्यालयों में कर्मकाण्ड का अध्ययन केवल परंपरागत रूप में नहीं, बल्कि वैज्ञानिक और ऐतिहासिक दृष्टिकोण से भी होता है।</li>
                <li>आधुनिक तकनीक (ऑनलाइन अनुष्ठान, डिजिटल धार्मिक सेवाएं) के साथ परंपराओं का तालमेल बैठाने की समझ विकसित होती है।</li>
            </ul>
        </>
    ),
    "timetable": (
        <>
            <p>सामग्री उपलब्ध नहीं है।</p>
        </>
    ),
    "achievements": (
        <>
            <p>सामग्री उपलब्ध नहीं है।</p>
        </>
    ),
    "contact": (
        <>
            <p>डॉ. हरीश कुमार, संयोजक</p>
            <p>कर्मकाण्ड/पौरोहित्य डिप्लोमा</p>
            <p>दूरभाष – 79883-76657</p>
        </>
    )
};

export default function KarmakandaPourohityaDiploma() {
    const [showSidebar, setShowSidebar] = useState(true);
    // Set default content to the first department's content
    const [currentContent, setCurrentContent] = useState(contentData[departments[0].id]);
    const [activeId, setActiveId] = useState(departments[0].id); // Track active item by ID

    // Effect to handle sidebar visibility on window resize for larger screens
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) { // Bootstrap's md breakpoint
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleItemClick = (deptId) => {
        setCurrentContent(contentData[deptId]);
        setActiveId(deptId); // Update active ID
        // Close sidebar on item click for small screens only
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }} // Added overflowY: 'auto'
            >
                <h5 className="text-center fw-bold mb-3 text-dark">कर्मकांड/पौरोहित्य डिप्लोमा</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            onClick={() => handleItemClick(dept.id)}
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer ${activeId === dept.id ? "text-white" : "text-dark"
                                }`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeId === dept.id ? "#77236b" : "white",
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto" // Added overflow-auto for main content
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) { // Only hide if sidebar is visible and on small screens
                        setShowSidebar(false);
                    }
                }}
            >

                <div>{currentContent}</div> {/* Display content from state */}
            </main>
        </div>
    );
}